import React from "react";
import { TouchableOpacity, View } from "react-native";
import { resolveIconURI } from "../../../../../helpers/utils";
import OutlookImage from "../../../../../assets/integrations/outlook.png";
import ImageComponent from "../../ImageComponent";

export default function OutlookIcon(props) {
  const width = props.width || 24;
  const height = props.height || 24;

  const TAG = props.onPress ? TouchableOpacity : View;


  return (
    <TAG style={props.styles} {...props}>
      <ImageComponent
        style={{ width, height }}
        image={resolveIconURI(OutlookImage)}
      />
    </TAG>
  );
}
